import React, { useEffect, useState } from 'react';
import { getCookie, setCookie } from './cookies';
import { updateGaConsent } from './GoogleAnalytics';

// Cookie/privacy consent banner that sets a short-lived consent cookie (6 months).
const COOKIE_NAME = 'ntc_cookie_consent';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 180; // 180 days (minimum common retention)

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    const existing = getCookie(COOKIE_NAME);
    if (!existing) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setCookie(COOKIE_NAME, 'accepted', COOKIE_MAX_AGE);
    updateGaConsent('granted');
    setVisible(false);
  };

  const handleDecline = () => {
    setCookie(COOKIE_NAME, 'declined', COOKIE_MAX_AGE);
    updateGaConsent('denied');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 inset-x-0 px-4 z-30">
      <div className="max-w-5xl mx-auto rounded-2xl border border-white/10 bg-slate-900/90 backdrop-blur shadow-xl p-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="text-sm text-slate-100">
          <p className="font-semibold">Cookies & Privacy</p>
          <p className="text-slate-300">
            We use essential cookies to run the site and optional analytics (if accepted) to improve your experience. You can read how we handle data in our Privacy Policy.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2 sm:flex-nowrap">
          <a
            href="/privacy-policy"
            className="inline-flex items-center justify-center rounded-full border border-white/20 px-4 py-2 text-sm font-semibold text-slate-100 hover:border-emerald-300"
          >
            Privacy Policy
          </a>
          <button
            onClick={handleDecline}
            className="inline-flex items-center justify-center rounded-full border border-white/20 px-4 py-2 text-sm font-semibold text-slate-100 hover:border-emerald-300"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="inline-flex items-center justify-center rounded-full bg-emerald-500 px-4 py-2 text-sm font-semibold text-slate-950 hover:bg-emerald-400"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
